import Field from "./Field";
import PhotoControl from "./PhotoControl";
import ProfileFields from "./ProfileFields";
import NumField from "./NumField";

export default function CoverPanel({ cover, contact, markup, onMarkup, vat, onVat, treatments, servicePrice, onTreat, onCover, onContact, onUpload, onRemove }) {
  const setCover = (key) => (value) => onCover({ ...cover, [key]: value });
  return (
    <div className="st-panel-body" data-testid="cover-panel">
      <PhotoControl image={cover.image} onUpload={onUpload} onRemove={onRemove} testPrefix="cover-photo" />
      <Field label="Titlu" value={cover.title} onChange={setCover("title")} testId="cover-title-input" />
      <Field label="Subtitlu" value={cover.subtitle} onChange={setCover("subtitle")} testId="cover-subtitle-input" />
      <Field label="Mesaj scurt" value={cover.tagline} onChange={setCover("tagline")} testId="cover-tagline-input" />
      <ProfileFields contact={contact} onContact={onContact} />
      <div className="st-section-title">Calcul prețuri</div>
      <div className="st-grid-2">
        <Field label="Adaos preț recomandat %" value={String(markup)} onChange={(v) => onMarkup(Math.max(0, parseInt(v, 10) || 0))} testId="markup-input" />
        <Field label="TVA %" value={String(vat)} onChange={(v) => onVat(Math.max(0, parseInt(v, 10) || 0))} testId="vat-input" />
      </div>
      <div className="st-section-title">Tratamente în salon</div>
      <div className="st-grid-2">
        <NumField label="Tratamente pe set" value={treatments} min={1} max={500} onCommit={(n) => onTreat({ treatments: n })} testId="treatments-input" />
        <NumField label="Preț minim serviciu (lei)" value={servicePrice} min={0} max={100000} onCommit={(n) => onTreat({ service_price: n })} testId="service-price-input" />
      </div>
      <p className="st-hint">Set = Pre-Shampoo 400 ml + Shampoo 500 ml + Conditioner 400 ml. Recalculează automat profitul pe pachete, în calculator, pe carduri și în PDF.</p>
    </div>
  );
}
